import PropTypes from 'prop-types';
import { memo, useEffect } from 'react';
import { LOAD, load } from 'model/payALoan';
import { selector } from 'selectors/payALoan';
import { Grid, Typography } from '@material-ui/core';
import { ReadOnlyFormControl } from 'components/common/fields';
import { Skeleton } from 'components/common';
import { useDispatch, useSelector } from 'react-redux';
import { filterByDDA } from 'consts';
import { useIsLoading } from 'hooks';

const ExpandedRow = ({ item = {} }) => {
  const dispatch = useDispatch();
  const fspId = item.fspId;
  const payerId = item.payerId;
  const stmtItems = useSelector((state) => selector(state));
  const isStatementsLoading = useIsLoading(LOAD);
  const statement = filterByDDA(item, stmtItems)[0];

  useEffect(() => {
    dispatch(
      load({
        fspId,
        payerId,
        suppressGlobalErrorSnackbar: true,
      })
    );
  }, [dispatch, fspId, payerId]);

  if (isStatementsLoading) {
    return <Skeleton />;
  }

  if (!statement?.id) {
    return <Typography>Statement update currently not available</Typography>;
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={3}>
            <ReadOnlyFormControl
              isDate
              label="Date of Loan"
              value={statement.createdAt}
            />
          </Grid>
          <Grid item xs={3}>
            <ReadOnlyFormControl
              isDate
              label="Statement Date"
              value={statement.stmtOn}
            />
          </Grid>
          <Grid item xs={3}>
            <ReadOnlyFormControl
              isDate
              label="Payment Due Date"
              value={statement.dueOn}
            />
          </Grid>
          <Grid>
            <Grid item xs={5}>
              <ReadOnlyFormControl
                label="Amount Due"
                value={statement.amtDueDerived}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} />
          </Grid>
          <Grid container>
            <Grid item xs={3}>
              <ReadOnlyFormControl
                label="Min Due"
                value={statement.minAmtDerived}
              />
            </Grid>
            <Grid item xs={3}>
              <ReadOnlyFormControl
                label="Updated At"
                value={statement.updatedAtDerived}
              />
            </Grid>

            <Grid item xs={3}>
              <ReadOnlyFormControl
                isDate
                label="Due Date"
                value={statement.dueOn}
              />
            </Grid>
            <Grid item xs={3}>
              <ReadOnlyFormControl
                label="Balance"
                value={statement.outstandingBalanceDerived}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

ExpandedRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default memo(ExpandedRow);
